<template>
  <div>
    <b-card
        v-if="settingsCoverDisplay=== 'full'"
        overlay
        :img-src="coverImgURL"
        :img-alt="`Cover for ${audio.title} - ${audio.artist}`"
        text-variant="white"
        :title="audio.title"
        title-tag="h2"
        :sub-title="audio.artist"
        sub-title-tag="h4"
        sub-title-text-variant="light"
        body-text-variant="black"
    >
      <template
          v-if="settingsShowSelectedBys&& selectedBys.length > 0"
          cols="6"
      >
        <b-card-text>
          Selected by
        </b-card-text>
        <b-img
            v-for="(aSelectedBy, sb) in selectedBys"
            v-bind="mainProps"
            :src="aSelectedBy.imgURL"
            rounded="circle"
            alt="Circle image"
            left
            :key="`sb_${sb}`"
        />
      </template>
    </b-card>
    <b-card
        v-else
        no-body overlay
        class="overflow-hidden"
    >
      <b-row>
        <b-col md="6">
          <b-card-img-lazy
            :src="coverImgURL"
            :alt="`Cover Image for ${audio.title}- ${audio.artist}`"
            class="rounded-0"
          />
        </b-col>
        <b-col md="6">
          <b-card-body :title="audio.title">
            <b-card-text>
              <h1>{{ audio.artist }}</h1>
            </b-card-text>
            <b-row>
              <b-cols v-if="settingsShowSelectedBys && selectedBys.length > 0" cols="6">
                Selected by
                <b-card v-for="(aSelectedBy, sb) in selectedBys"
                        rounded-5
                        style="background-color: #bbb3b5; corner-radius:25px;"
                        :key="`sb_${sb}`"
                >
                  <b-row>
                    <b-cols cols="6">
                      <b-img
                          v-bind="mainProps"
                          :src="aSelectedBy.imgURL"
                          rounded="circle"
                          alt="Circle image"
                          left
                      />
                    </b-cols>
                    <b-cols cols="6">
                      <b-card-text style="padding: 20px 0;">
                        {{aSelectedBy.name}}
                      </b-card-text>
                    </b-cols>
                  </b-row>
                </b-card>
              </b-cols>
            </b-row>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "AudioRow",
  props: {
    audio: {
      type: Object,
      default: () => {}
    },
    assetsUrlHome: {
      type: String,
      default: ""
    },
    settingsCoverDisplay: {
      type: String,
      default: 'full'  //cover | side
    },
    settingsShowSelectedBys: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    coverImgURL() {
      return this.audio.imgURL
        ? `${this.assetsUrlHome}${this.audio.imgURL}`
        : "";
    },
    iconImgProps() {
      if (this.audio.imgURL) {
        this.mainProps.src = `${this.assetsUrlHome}${this.audio.imgURL}`;
      }
      return this.mainProps;
    },
    selectedBys() {
      return  this.audio.selectedBys && Array.isArray(this.audio.selectedBys)?
          this.audio.selectedBys : [];
    },
    createdAt() {
      return 'time';
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
